export default __webpack_public_path__ + "static/media/btn-color-it_it@2x.b961319f.png";